import styled from '@emotion/styled';
import { getTypographyCss, theme } from '@revenuemarket/design';

import { InlineCss } from '../types/common';

export const ErrorMessage = styled.div<InlineCss>`
  color: ${theme.semanticColors.danger.regular};
  ${getTypographyCss('caption1')};

  ${({ inlineCss }) => inlineCss};
`;
